// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"223":"bca90bf249ce199e","761":"aef35015e69afd6d","910":"cf439cf35d60008e"}[chunkId] + ".js";
};